<template>
  <div>
    <Dialog
      :dismissableMask="true"
      :modal="true"
      :visible.sync="show"
      @hide="closeDialog"
      :contentStyle="{ overflow: 'visible' }"
      :maximizable="true"
    >
      <template #header>
        <i style="transform: scale(1.7)" class="pi pi-briefcase"></i>
        <h1 style="text-align: center" class="p-pr-3 p-pl-3">דיווח משמעת</h1>
      </template>
      <div class="p-pt-4 p-ai-center vertical-container p-flex-column p-grid">
        <div class="p-col">
          <!--   subjectTracing  -->
          <Dropdown
			filterPlaceholder=" חפש לפי נושא"
			emptyFilterMessage=" לא נמצא שם נושא תואם"
			:filter="true"
			dataKey="id"
			optionLabel="hebrewName"

			v-model="newItem.subject"
            :options="subjectTracingFilter"
            placeholder="נושא האירוע"
            data-key="id"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span class="subject-tracking" :class="slotProps.value.type"
                  >{{ slotProps.value.hebrewName }}
                </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span class="subject-tracking" :class="slotProps.option.type"
                >{{ slotProps.option.hebrewName }}
              </span>
            </template>
          </Dropdown>
        </div>
        <!--   content  -->
        <div class="p-col-12 twrap p-d-flex p-jc-center">
          <Textarea
            cols="30"
            placeholder="תוכן האירוע"
            type="text"
            v-model="newItem.content"
          />
          <!--            <InputText  />-->
        </div>

        <!--   teacher  -->
        <div v-if="user.role === 'ADMIN'" class="p-field p-col">
          <Dropdown
            filterPlaceholder=" חפש לפי שם משפחה"
            emptyFilterMessage=" לא נמצא שם משפחה תואם"
            class="p-dropdown-filter-container"
            :filter="true"
            optionLabel="lastname"
            v-model="newItem.teacher"
            :options="teachers"
            placeholder="בחר מורה השייך לאירוע"
            dataKey="id"
          >
            <template #value="slotProps">
              <div v-if="!slotProps.value || slotProps.value.length === 0">
                {{ slotProps.placeholder }}
              </div>
              <span v-else>
                {{ slotProps.value.firstname }} {{  slotProps.value.lastname }}
              </span>
            </template>
            <template #option="slotProps">
              <span>
                {{ slotProps.option && slotProps.option.firstname }}
                {{slotProps.option &&  slotProps.option.lastname }}</span
              >
            </template>
          </Dropdown>
        </div>

        <div class="p-grid p-pt-3 p-jc-between">
          <!-- time -->
          <div
            v-tooltip.top="'תלמיד'"
            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
          >
            <i class="pi p-pt-3 pi-clock" style="font-size: 1.5rem"></i>
            <Divider type="dashed" class="divider-short-dialog" />
            <h3 style="text-align: center !important">
              {{pupil && pupil.firstname }} {{pupil && pupil.lastname }}
            </h3>
          </div>

          <!-- date-->
          <div
            v-tooltip.top="'תאריך'"
            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
          >
            <i class="pi p-pt-3 pi-calendar" style="font-size: 1.5rem"></i>
            <Divider type="dashed" class="divider-short-dialog" />
            <h3 style="text-align: center !important">{{ dateformat }}</h3>
          </div>

          <!-- grade-->
          <div
            v-tooltip.top="'כיתה'"
            class="selected-details p-col p-grid p-jc-center p-m-2 p-p-2"
          >
            <i class="pi p-pt-3 pi-th-large" style="font-size: 1.5rem"></i>
            <Divider type="dashed" class="divider-short-dialog" />
            <h3 style="text-align: center !important">
              {{grade && grade.hebrewName }}
            </h3>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          label="ביטול"
          icon="pi pi-times"
          @click="closeDialog"
          class="p-button-secondary"
        />
        <Button
          v-if="validateToPost"
          class="p-button-success"
          label="שלח דיווח"
          icon="pi pi-check"
          @click="post"
        />
        <Button
          v-else
          disabled="disabled"
          class="p-button-success"
          label="שלח דיווח"
          icon="pi pi-check"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../service/Service";
import { mapState } from "vuex";
import { dateToFullHebrew } from "../../src/utils/hebrewDateFormat";

export default {
  service: null,
  props: {
    show: Boolean,
    pupil: Object,
    date: Date,
    grade: Object,
  },
  created() {
    this.service = new Service();
    this.service.get("teacher").then((data) => {
      this.teachers = data;
    });
    this.setNewItemFields();
  },
  computed: {
    dateformat() {
      return dateToFullHebrew(this.date);
    },
    validateToPost() {
      return this.newItem.subject !== null;
    },
    ...mapState(["presenceStatus", "pupils", "user", "subjectTracing"]),
    subjectTracingFilter() {
      if (this.user?.role !== "ADMIN") {
        return this.subjectTracing.filter((s) => s.role !== "ADMIN");
      } else {
        return this.subjectTracing;
      }
    },
  },
  data() {
    return {
      newItem: null,
      teachers: null,
    };
  },

  methods: {
    getGradeObj(gradeId) {
      return this.gradeOptions.find((grade) => grade.id === gradeId);
    },
    setNewItemFields() {
      this.newItem = {
        content: null,
        subject: null,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      const dateParse = Date.parse(this.date);
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem.subject === null) {
          validate = false;
        }
      }

      if (validate === true) {
        this.closeDialog();

        const obj = JSON.parse(JSON.stringify(this.newItem));
        obj.subject = obj.subject.id;
        obj.grade = this.grade.id;  
        obj.date = dateParse;

        obj.pupil = this.pupil.id;
        obj.user = this.user.id;

        if (this.newItem.teacher)
          this.user.role === "ADMIN"
            ? (obj.teacher = this.newItem?.teacher?.id)
            : (obj.teacher = this.user.id);

        await this.service
          .post(obj, "tracing")
          .then(() => {
            this.setNewItemFields();
              this.$emit("updateTracking");

              this.openNotification("success", `מעולה`, `הדיווח נקלט במערכת`);
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `קרתה תקלה בשמירת הנתונים במערכת`
            );
          });
      } else {
        this.openNotification("danger", `אופס`, `חסרים כמה שדות למילוי`);
      }
    },
    openNotification(
      color,
      title,
      text,
      position = "right-left",
      duration = 3000
    ) {
      this.$vs.notification({
        color,
        position,
        title,
        text,
        duration,
        progress: "auto",
      });
    },
  },
};
</script>

<style>
textarea {
  /*width: 80%;*/
  resize: both !important;
}

.twrap {
  overflow: hidden;
  padding: 0 4px 0 12px;
}

.selected-details {
  background: #faf1d4;
  /*border: 1px solid rgba(132, 128, 128, 0.52);*/
}

@media screen and (max-width: 1200px) {
  .p-dialog {
    width: 55vw;
  }
}

@media screen and (max-width: 992px) {
  .p-dialog {
    width: 65vw;
  }
}

@media screen and (max-width: 768px) {
  .p-dialog {
    width: 75vw;
  }
}

@media screen and (max-width: 576px) {
  .p-dialog {
    width: 85vw;
  }
}
</style>